<template>
  <div class="dialog-root">
    <div class="container">
      <el-form ref="formRef" :model="formData" label-width="130px">
        <el-row>
          <el-col span="12">
            <el-form-item
              prop="serviceNo"
              label="话务号："
              :rules="[{ required: true, message: '请输入话务号', trigger: 'blur' }]"
            >
              <el-input
                v-model="formData.serviceNo"
                placeholder="请输入 话务号"
                maxlength="20"
                show-word-limit
                clearable
                :disabled="dialogType == 'add' ? false : true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="serviceName"
              label="坐席名称："
              :rules="[{ required: true, message: '请输入坐席名称', trigger: 'blur' }]"
            >
              <el-input
                v-model="formData.serviceName"
                placeholder="请输入 坐席名称"
                maxlength="20"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="坐席工号：">
              <el-input
                v-model="formData.serviceCode"
                placeholder="请输入 坐席工号"
                maxlength="20"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">
        {{ dialogType == 'add' ? '保存' : '修改' }}
      </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { addApi, updateApi } from '@/api/call-system/call-manage/AI-operator-manage';

export default {
  props: ['dialogType', 'projectId', 'rowData'],
  data() {
    return {
      formData: {}, // 表单数据
    };
  },
  created() {
    if (this.dialogType == 'edit') {
      let { id, serviceNo, serviceName, serviceCode } = this.rowData;
      this.formData = { id, serviceNo, serviceName, serviceCode };
    } else {
      this.formData.projectId = this.projectId;
    }
  },
  methods: {
    /* 保存 */
    doSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let fn = this.dialogType == 'add' ? addApi : updateApi;
          fn(this.formData, {
            showLoading: { text: '处理中...' },
          }).then(() => {
            this.$message.success('操作成功!');
            this.$emit('update');
          });
        }
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
</style>
